import { useEffect } from 'react';

export function useOneTrust() {
  useEffect(() => {
    // Ensure OneTrust is initialized
    if (typeof window.OptanonWrapper !== 'function') {
      window.OptanonWrapper = function() {};
    }

    // Reload OneTrust notices when component mounts
    if (window.OneTrust?.NoticeApi?.LoadNotices) {
      window.OneTrust.NoticeApi.LoadNotices(['cookie']);
    }

    // Fix for scrolling issue after consent is given
    const handleConsentChange = () => {
      // Ensure body overflow is reset
      document.body.style.overflow = '';
      document.body.classList.remove('ot-hide-scrollbar');
      document.documentElement.classList.remove('ot-hide-scrollbar');
    };

    // Add event listener for OneTrust consent changes
    if (typeof window.OneTrust !== 'undefined' && window.OneTrust.OnConsentChanged) {
      window.OneTrust.OnConsentChanged(handleConsentChange);
    }

    // Add a mutation observer to detect when the banner is removed from DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          // Check if any removed node is the banner
          for (let i = 0; i < mutation.removedNodes.length; i++) {
            const node = mutation.removedNodes[i];
            if (node.id === 'onetrust-banner-sdk' || 
                (node.nodeType === Node.ELEMENT_NODE && node.querySelector('#onetrust-banner-sdk'))) {
              // Banner was removed, ensure body can scroll
              document.body.style.overflow = '';
              document.body.classList.remove('ot-hide-scrollbar');
              document.documentElement.classList.remove('ot-hide-scrollbar');
              break;
            }
          }
        }
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup function
    return () => {
      observer.disconnect();
      // Remove event listener if possible
      if (typeof window.OneTrust !== 'undefined' && window.OneTrust.OnConsentChanged) {
        try {
          window.OneTrust.OnConsentChanged(null);
        } catch (e) {
          // Ignore errors when trying to remove listener
        }
      }
    };
  }, []);
}